import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Divider, Row, Col, Button, List, Switch, message } from "antd";
import { LeftOutlined} from "@ant-design/icons";
import { global_var } from '../services/cs-lab-config';
import { servManageAiFeatures } from "../services/ide-apis";
import ClassRoomMasterLoader from './common/classroom-master-loader';


const ManageAiFeatures = () => {
    const aiFeaturesArray = ['Ai chatbot', 'ai code generator']
    const [aiSettingsArray, setAiSettingsArray] = useState([])
    const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true)
    const [selectedClass, setSelectedClass] = useState(null);

    useEffect(() => {

      setAiSettingsArray(global_var.assignedAiFeatures || []);
      if (selectedClass) {
        setIsSaveButtonDisabled(false)
      }

    }, [selectedClass]);


    const handleToggle = (featureName, selectedClass) => {
      setAiSettingsArray((prev) => {
        const existingFeature = prev.find((featureObj) => featureObj.aiFeature === featureName);
    
        // Case 1: Feature exists in the array
        if (existingFeature) {
          return prev.map((featureObj) => {
            if (featureObj.aiFeature === featureName) {
              // If selecting "all"
              if (selectedClass === "all") {
                const hasAll = featureObj.enabledClasses.includes("all");
                return {
                  ...featureObj,
                  enabledClasses: hasAll ? [] : ["all"] // Toggle "all"
                };
              }
              
              // If selecting individual class
              const hasClass = featureObj.enabledClasses.includes(selectedClass);
              let newEnabledClasses = featureObj.enabledClasses;
    
              if (hasClass) {
                // Remove the class if it exists
                newEnabledClasses = newEnabledClasses.filter(classId => classId !== selectedClass);
              } else {
                // Add the class and ensure "all" is removed
                newEnabledClasses = [
                  ...newEnabledClasses.filter(classId => classId !== "all"),
                  selectedClass
                ];
              }
    
              return {
                ...featureObj,
                enabledClasses: newEnabledClasses
              };
            }
            return featureObj;
          });
        }
    
        // Case 2: Feature doesn't exist in the array
        return [...prev, {
          aiFeature: featureName,
          enabledClasses: selectedClass === "all" ? ["all"] : [selectedClass]
        }];
      });
    };
  
  
  

    const handleSave = async() => {
      const updateObj = {companyId:global_var.company_id}  
      
      if(global_var.parent_company_id) {
          updateObj.parentCompanyId = global_var.parent_company_id
      }

      if (aiSettingsArray) {
        updateObj.aiSettingsArray = aiSettingsArray;
      }

      try {
          const response = await servManageAiFeatures(updateObj);

          if (response?.data?.statusCode === 200) {
            message.success(response.data.message);
            global_var.assignedAiFeatures = aiSettingsArray;
          }

      } catch (error) {
        message.success();
      } 
        
    }

    const handleClassChange = (classId) => {
      setSelectedClass(classId);
    };

    return(
        <>
            <Row className="mt-3">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link to="/" className="mr-2">
          <span className="mt-2 back-button">
            <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
          </span>
          </Link>
          <span className="m-1 mt-2 h4 poppins-medium">Assign Ai features</span>
        </Col>
      </Row>

      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>

      <div style={{ overflowX: 'auto' }} className="mobile-card-scrollbar">
        <Row className='mt-4 mx-md-3' style={{ flexFlow: 'row' }}>
          <Col className='d-flex'>
            
              <ClassRoomMasterLoader
              classId={selectedClass}
              onChange={handleClassChange}
              showAllOption={true}
              selectMultiple={false}
              loadAllClassRoom={true}
            />
            
            
    
          </Col>
        </Row>
      </div>


      <Row className='bg-white p-3 rounded-3 m-2 mt-3'>
        <Col xs={18} md={10}>
          <Row className='mx-2 mb-2'>
            <Col>
              <span className='poppins-medium' style={{fontSize:'18px'}}>Available Ai features</span>
              <span className='poppins-regular text-midgrey d-block'>Activate / Deactivate from below</span>
            </Col>
          </Row>

          <Row className='mx-2'>
            <Col xs={24}>
            <List className='mt-2 menu-list'
              dataSource={aiFeaturesArray}
              renderItem={(item) => {
              // Find the feature object from aiSettingsArray based on the item (aiFeature)
              const featureObj = aiSettingsArray ? aiSettingsArray.find((feature) => feature.aiFeature === item) : null;

              // Check if the selected class is enabled for this feature
              const isClassAssigned = featureObj 
              ? (selectedClass === "all" 
                  ? featureObj.enabledClasses.includes("all")  // Check if "all" exists in array
                  : featureObj.enabledClasses.includes(selectedClass)) // Check for specific class
              : false;

              return (
                  <List.Item 
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span className='poppins-regular'>{item}</span>
                      <Switch 
                          checked={isClassAssigned} // Switch is checked if the class is assigned
                          style={{ backgroundColor: isClassAssigned ? '#83C545' : '#dfdfdf' }}                      
                          onChange={() => handleToggle(item, selectedClass)} // Pass both item and class to handleToggle
                      />
                  </List.Item>
                );
              }}
            />   
                
            </Col>
          </Row>
        </Col>

        <Divider />
        <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="primary" 
          onClick={handleSave} disabled={isSaveButtonDisabled}
          >
            Save Changes
          </Button>
        </Col>
      </Row>
        </>
    )
}

export default ManageAiFeatures;